import { AppTabContent } from "@/modules/finance/components/tabs/AppTabContent";

export const FinanceScreen = () => {
  return <AppTabContent />;
};
